<template>
    <loading v-model:active="isLoading" :can-cancel="false" :on-cancel="onCancel" :is-full-page="fullPage" />
    <div class="container-fluid">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/client">Clientes</router-link></li>
                <li class="breadcrumb-item active" aria-current="page">Atualizar serviços / {{ client.name }}</li>
            </ol>
        </nav>
        <div class="row" v-if="enable_error_list">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="alert alert-danger">
                    <ol>
                        <li v-for="(error, index) in errors" :key="index">{{ error[0] }}</li>
                    </ol>
                </div>
            </div>
        </div>
        <div class="row" v-if="signature">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="alert alert-success">Solicitação assinatura realizada com sucesso. <i
                        class="fa fa-copy pointer" @click="copyLinkSignature()"> Clique aqui</i> para copiar o link
                </div>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <tabMenuClient :id="client.id" :type="client.type"></tabMenuClient>
                <div class="tab-content">
                    <div class="tab-pane active" role="tabpanel" id="info">
                        <div class="card shadow mb-4 mt-4">
                            <a href="#collapseCardForm" class="d-block card-header py-3"
                                :class="noOpenForm ? 'collapsed' : ''" data-toggle="collapse" role="button"
                                :aria-expanded="noOpenForm ? false : true" aria-controls="collapseCardForm">
                                <h6 class="m-0 font-weight-bold text-primary"><i class="fa"
                                        :class="text_label == 'Adicionar serviço ao contrato' ? 'fa-plus' : 'fa-edit'"></i>
                                    {{ text_label }}</h6>
                            </a>
                            <div class="collapse" :class="noOpenForm ? '' : 'show'" id="collapseCardForm">
                                <div class="card-body">
                                    <form @submit="update">
                                        <div class="row">
                                            <div class="col-xl-12 col-md-12 col-sm-12">
                                                <label for="">Serviço*</label>
                                                <multiselect v-model="service_multiselect" :options="services_options"
                                                    :custom-label="serviceWithLang" placeholder="Selecione uma opção"
                                                    :select-label="'Clique para selecionar'"
                                                    :deselect-label="'Clique para remover'"
                                                    @select="handleSelectService">

                                                    <template #noResult>
                                                        Nenhum serviço encontrado.
                                                    </template>
                                                </multiselect>
                                            </div>
                                        </div>
                                        <div class="row mt-3">
                                            <div class="col-xl-4 col-md-4 col-sm-12">
                                                <label for="">Valor contrato*</label>
                                                <input type="text" class="form-control" placeholder="R$ 0,00"
                                                    v-model.lazy="client_service.amount" v-money="money">
                                            </div>
                                            <div class="col-xl-4 col-md-4 col-sm-12">
                                                <label for="">Contrato recorrente*</label>
                                                <select class="form-control" v-model="client_service.recurrence">
                                                    <option value="" disabled selected>Escolha uma opção</option>
                                                    <option value="1">Sim</option>
                                                    <option value="0">Não</option>
                                                </select>
                                            </div>
                                            <div class="col-xl-4 col-md-4 col-sm-12">
                                                <label for="">Quantidade de colaboradores</label>
                                                <input type="text" class="form-control" placeholder="Ex: 1"
                                                    v-model="client_service.employees" v-mask="['####.####']">
                                            </div>
                                        </div>
                                        <div class="row mt-3">
                                            <div class="col-xl-4 col-md-4 col-sm-12">
                                                <label for="">Data início contrato</label>
                                                <input type="date" class="form-control"
                                                    v-model="client_service.date_start_contract">
                                            </div>
                                            <div class="col-xl-4 col-md-4 col-sm-12">
                                                <label for="">Data fim contrato</label>
                                                <input type="date" class="form-control"
                                                    v-model="client_service.date_end_contract">
                                            </div>
                                            <div class="col-xl-4 col-md-4 col-sm-12">
                                                <label for="">Data renovação contrato</label>
                                                <input type="date" class="form-control"
                                                    v-model="client_service.date_renovation_contract">
                                            </div>
                                        </div>
                                        <div class="row mt-3">
                                            <div class="col-xl-3 col-md-3 col-sm-12">
                                                <label for="">Pró-Labore</label>
                                                <select class="form-control" v-model="client_service.pro_labore">
                                                    <option value="" disabled selected>Escolha uma opção</option>
                                                    <option value="1">Sim</option>
                                                    <option value="0">Não</option>
                                                </select>
                                            </div>
                                            <div class="col-xl-3 col-md-3 col-sm-12">
                                                <label for="">Emissão NF</label>
                                                <select class="form-control" v-model="client_service.emission_nf">
                                                    <option value="" disabled selected>Escolha uma opção</option>
                                                    <option value="1">Sim</option>
                                                    <option value="0">Não</option>
                                                </select>
                                            </div>
                                            <div class="col-xl-3 col-md-3 col-sm-12">
                                                <label for="">Contrato assinado</label>
                                                <select class="form-control" v-model="client_service.signed_contract">
                                                    <option value="" disabled selected>Escolha uma opção</option>
                                                    <option value="1">Sim</option>
                                                    <option value="0">Não</option>
                                                </select>
                                            </div>
                                            <div class="col-xl-3 col-md-3 col-sm-12">
                                                <label for="">Dia vencimento</label>
                                                <select class="form-control" v-model="client_service.due_date">
                                                    <option value="" disabled selected>Escolha uma opção</option>
                                                    <option v-for="n in 28" :key="n" :value="n">{{ n }}</option>

                                                </select>
                                            </div>
                                        </div>
                                        <div class="row mt-2">
                                            <div class="col-lg-12 col-xs-12 col-sm-12">
                                                <label for="">Observações</label>
                                                <editorText @update-text="updateObservation"
                                                    :modelValue="client_service.observation"
                                                    placeholderSend="Sem observações" ref="myChild"></editorText>
                                            </div>
                                        </div>
                                        <div class="row mt-4">
                                            <div class="col-xl-12 col-md-12 col-sm-12">
                                                <button type="submit" :disabled='!isDisabled' class="btn btn-info"><i
                                                        class="fa fa-save"></i> {{ button_action
                                                        }}</button>
                                                <button type="button" @click="cancel" class="btn btn-danger ml-3"><i
                                                        class="fa fa-times"></i> Cancelar</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tab-content">
                    <div class="tab-pane active" role="tabpanel" id="info">
                        <div class="card shadow mb-4">
                            <!-- Card Header - Dropdown -->
                            <div class="card-body">
                                <div
                                    class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                                    <h6 class="m-0 font-weight-bold text-primary">Serviços contratados</h6> <button
                                        class="btn btn-success" v-if="client_services_saved.length > 0" @click="confirmSignatureContract"><i
                                            class="fa fa-file-signature"></i> Solicitar assinatura contrato</button>
                                </div>
                                <div class="row">
                                    <div class="col-xl-12 col-md-12 col-sm-12">
                                        <div class="table-responsive">
                                            <table class="table" id="dataTable" width="100%" cellspacing="0">
                                                <thead>
                                                    <tr>
                                                        <th>Serviço</th>
                                                        <th class="text-center">Valor</th>
                                                        <th class="text-center">Colaboradores</th>
                                                        <th class="text-center">Pró-labore</th>
                                                        <th class="text-center">Emissão NF</th>
                                                        <th class="text-center">Contrato assinado</th>
                                                        <th class="text-center">Dia vencimento</th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(service) in client_services_saved" :key="service.id">
                                                        <td class="align-middle">{{ service.name_service }} <br>
                                                            <span v-if="service.date_start_contract != ''"
                                                                class="badge badge-info mr-2">Início contrato:
                                                                {{ service.date_start_contract_formatted }} </span>
                                                            <span v-if="service.date_end_contract != ''"
                                                                class="badge badge-info mr-2">Validade:
                                                                {{ service.date_end_contract_formatted }}</span>
                                                            <span v-if="service.date_renovation_contract != ''"
                                                                class="badge badge-danger mr-2">Renovação:
                                                                {{ service.date_renovation_contract_formatted }}</span>
                                                            <span v-if="service.recurrence"
                                                                class="badge badge-success">Tipo:
                                                                Recorrente</span>
                                                            <span v-if="!service.recurrence"
                                                                class="badge badge-warning">Tipo:
                                                                Avulso</span>
                                                        </td>
                                                        <td class="text-center">{{ service.amount_formatted }}
                                                        </td>
                                                        <td class="text-center">{{ service.employees }} </td>
                                                        <td class="text-center">
                                                            <span class="badge badge-success"
                                                                v-if="service.pro_labore">Sim</span>
                                                            <span class="badge badge-danger" v-else>Não</span>
                                                        </td>
                                                        <td class="text-center">
                                                            <span class="badge badge-success"
                                                                v-if="service.emission_nf">Sim</span>
                                                            <span class="badge badge-danger" v-else>Não</span>
                                                        </td>
                                                        <td class="text-center">
                                                            <span class="badge badge-success"
                                                                v-if="service.signed_contract">Sim</span>
                                                            <span class="badge badge-danger" v-else>Não</span>
                                                        </td>
                                                        <td class="text-center">
                                                            <span class="badge badge-info" v-if="service.due_date">{{
                                                                service.due_date
                                                                }}</span>
                                                            <span class="badge badge-danger" v-else>-</span>
                                                        </td>
                                                        <td>
                                                            <div class="dropdown">
                                                                <button class="btn btn-primary dropdown-toggle"
                                                                    type="button" id="dropdownMenuButton"
                                                                    data-toggle="dropdown" aria-haspopup="true"
                                                                    aria-expanded="false">
                                                                    Ações
                                                                </button>
                                                                <div class="dropdown-menu animated--fade-in"
                                                                    aria-labelledby="dropdownMenuButton">
                                                                    <button class="dropdown-item"
                                                                        @click="editService(service.id)">Detalhes</button>
                                                                    <button class="dropdown-item"
                                                                        @click="deleteService(service.id)">Excluir</button>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>

                                                    <tr v-show="client_services_saved.length <= 0">
                                                        <td colspan="8" class="text-center">Nenhum registro encontrado
                                                        </td>
                                                    </tr>
                                                    <tr v-show="client_services_saved.length > 0">

                                                        <td colspan="9" class="text-left">Total em serviços: <strong>
                                                                {{ total_service }}</strong></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api';
import { handleRequestErrors } from '@/handleErrors';
import { capitalize } from '@/util';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import { mask } from 'vue-the-mask'
import tabMenuClient from './tab-menu-client.vue';
import Multiselect from 'vue-multiselect'
import { VMoney } from 'v-money'
import editorText from '../util/editor-text.vue';

export default {
    directives: { mask, money: VMoney },
    components: { Loading, tabMenuClient, Multiselect, editorText },
    data() {
        return {
            isLoading: true,
            fullPage: true,
            client: {},
            services: {},
            service_multiselect: '',
            client_services_saved: {},
            services_options: [],
            client_id: '',
            action_save: true,
            text_label: 'Adicionar serviço ao contrato',
            button_action: 'Cadastrar',
            total_service: 0.00,
            noOpenForm: true,
            signature: false,
            url_signature: '',
            client_service: {
                id: '',
                service_id: '',
                employees: '',
                pro_labore: '',
                emission_nf: '',
                signed_contract: '',
                client_service_id: '',
                amount: '',
                recurrence: '',
                date_start_contract: '',
                date_end_contract: '',
                date_renovation_contract: '',
                due_date: '',
                observation: ''
            },
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            },
            enable_error_list: false,
            errors: [],

        }
    },

    computed: {
        isDisabled: function () {
            return this.client_service.service_id != '' && this.client_service.amount != '' && this.client_service.recurrence != '';
        }
    },
    mounted() {
        this.isLoading = false;
        const id = this.$route.params.id;
        this.client_id = id;
        this.loadServices();
        this.getServiceClient();

    },
    methods: {
        onCancel() { },
        cancel() {
            this.action_save = false;
            this.client_service = { service_id: '', employees: '', pro_labore: '', emission_nf: '', signed_contract: '', recurrence: '' };
            this.services = {};
            this.client_services_saved = {};
            this.text_label = 'Adicionar serviço ao contrato';
            this.button_action = 'Cadastrar';
            this.loadServices();
            this.getServiceClient();
            this.noOpenForm = true;
        },
        updateObservation(observation) {
            this.client_service.observation = observation;
        },
        setCapitalize(text) {
            return capitalize(text);
        },
        handleSelectService(option) {
            this.client_service.service_id = option.key;
            this.client_service.amount = option.price;
        },
        serviceWithLang({ value }) {
            return value;
        },
        formatReal(value) {
            return new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            }).format(value);
        },

        calculateTotalServices() {
            let sum = 0;
            this.client_services_saved.forEach(service => {
                sum += parseFloat(service.amount);
            });

            this.total_service = this.formatReal(sum);
        },

        loadServices() {
            this.service_multiselect = '';
            this.services_options = [];
            const response_services = this.getServices();
            response_services.then(() => {
                this.services_options = this.services.map(item => ({
                    key: item.id,
                    value: item.name,
                    price: item.amount_formatted
                }));
            });
        },

        async getServices() {
            const response = api.get('/serviceAll')
                .then((response) => {
                    this.isLoading = false;
                    this.services = response.data.services;

                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status, error);
                });

            return response;
        },

        getServiceClient() {
            this.isLoading = true;
            api.get('/client/' + this.client_id + '/service')
                .then((response) => {
                    this.isLoading = false;
                    this.client = response.data.client;
                    this.client_services_saved = response.data.services_client;
                    this.calculateTotalServices();
                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status, error);
                })
        },

        update(event) {
            event.preventDefault();
            this.enable_error_list = false;
            this.isLoading = true;
            api.post('/client/' + this.client.id + '/service', this.client_service)
                .then(() => {
                    this.isLoading = false;
                    if (this.action_save) {
                        this.$notify({
                            title: "Sucesso",
                            text: "Serviço adicionado com sucesso!",
                            type: 'success'
                        });
                    } else {
                        this.$notify({
                            title: "Sucesso",
                            text: "Serviço atualizado com sucesso!",
                            type: 'success'
                        });
                    }

                    this.cancel();

                }).catch(error => {
                    this.isLoading = false;
                    if (error.status == 422) {
                        let response_errors = error.response.data.errors;
                        this.errors = response_errors;
                        this.enable_error_list = true;
                    }
                    handleRequestErrors(error.status);
                })

        },
        editService(service_id) {
            this.text_label = 'Atualizar serviço';
            this.button_action = 'Atualizar';
            this.client_services_saved.forEach(service => {
                if (service.id == service_id) {
                    this.client_service.service_id = service.id_service;
                    this.client_service.client_service_id = service.id;
                    this.client_service.employees = service.employees ? service.employees.toString() : '';
                    this.service_multiselect = { key: service.id, value: service.name_service };
                    this.client_service.pro_labore = service.pro_labore ? '1' : '0';
                    this.client_service.emission_nf = service.emission_nf ? '1' : '0';
                    this.client_service.signed_contract = service.signed_contract ? '1' : '0';
                    this.client_service.amount = service.amount != '0.00' ? service.amount_formatted : service.amount_service_formatted;
                    this.client_service.recurrence = service.recurrence ? '1' : '0';
                    this.client_service.date_start_contract = service.date_start_contract;
                    this.client_service.date_end_contract = service.date_end_contract;
                    this.client_service.date_renovation_contract = service.date_renovation_contract;
                    this.client_service.due_date = service.due_date;
                    this.client_service.observation = service.observation;
                    this.$refs.myChild.updateTextEditor(this.client_service.observation);
                    this.noOpenForm = false;
                }
            });
        },
        deleteService(id) {
            this.$confirm(
                {
                    message: 'Deseja retirar o serviço do cliente?',
                    button: {
                        no: 'Não',
                        yes: 'Sim'
                    },

                    callback: confirm => {
                        if (confirm) {
                            this.isLoading = true;
                            api.delete('client/' + id + '/service')
                                .then(() => {
                                    this.isLoading = false;
                                    this.$notify({
                                        title: "Sucesso",
                                        text: "Serviço removido com sucesso",
                                        type: 'success'
                                    });

                                    this.cancel();
                                }).catch(error => {
                                    this.isLoading = false;
                                    handleRequestErrors(error.status);
                                })
                        }
                    }
                }
            )
        },

        confirmSignatureContract() {
            this.$confirm(
                {
                    message: 'Deseja solicitar solicitar a assinatura do contrato?',
                    button: {
                        no: 'Não',
                        yes: 'Sim'
                    },

                    callback: confirm => {
                        if (confirm) {
                            this.isLoading = true;
                            api.post('/client/' + this.client_id + '/signature')
                                .then(() => {
                                    this.isLoading = false;
                                    this.$notify({
                                        title: "Sucesso",
                                        text: "Solicitação realizada com sucesso",
                                        type: 'success'
                                    });
                                    this.loadServices();
                                    this.signature = true;
                                }).catch(error => {
                                    this.isLoading = false;
                                    this.signature = false;
                                    handleRequestErrors(error.status);
                                })
                        }
                    }
                }
            )
        },
        copyLinkSignature() {
            this.url_signature = process.env.VUE_APP_SIGNATURE;
            this.url_signature = this.url_signature + '?client_id=' + this.client_id;
            navigator.clipboard.writeText(this.url_signature);
            this.$notify({
                title: "Informação",
                text: "Lino copiado!",
                type: 'success'
            });
        }
    }
}
</script>

<style lang="scss" scoped></style>